module.exports = __webpack_public_path__ + "img/viptq.9334f4ea.png";